import { InputNumber, message, Spin } from 'ant-design-vue'
import { defineComponent, type PropType, reactive, watchEffect } from 'vue'
import { useRefresh } from '../../hooks/useTableRefresh'
import CellMixin from '../CellMixin'
import { CheckOutlined } from '@ant-design/icons-vue'
import styles from './index.module.less'
import type { IConfig } from '../../types'
export default defineComponent({
  name: 'OrderCell',
  mixins: [CellMixin],
  props: {
    orderFn: {
      type: Object as PropType<IConfig['orderAction']>,
      default: null
    }
  },
  setup(props) {
    const { refreshTable } = useRefresh()
    const state = reactive({
      loading: false,
      tmp: props.text
    })
    watchEffect(() => {
      state.tmp = props.text
    })
    const handleSave = async () => {
      state.loading = true
      const _params = { data: [{ id: props.record.id, order: state.tmp }] }
      const params = props.orderFn?.before?.(_params) ?? _params
      try {
        await props.orderFn?.fn?.(params)
        message.success('更新排序成功')
        refreshTable()
      } catch (err) {
        message.error('更新排序失败')
      }
      state.loading = false
    }
    return () => (
      <Spin spinning={state.loading}>
        <div class={styles.box}>
          <InputNumber v-model={[state.tmp, 'value']} min={0} precision={0} max={999} />
          {state.tmp !== props.text && (
            <div onClick={handleSave}>
              <CheckOutlined class={styles.save} />
            </div>
          )}
        </div>
      </Spin>
    )
  }
})
